import type { Loan } from '../types/portal'

export const milestones = [
  'Application',
  'Processing',
  'Underwriting',
  'Conditions',
  'Clear to Close',
  'Funded',
]

export const loans: Loan[] = [
  {
    id: 'LN-70118',
    borrower: 'Nathaniel Okafor',
    amount: '$429,000',
    program: 'Conventional 30-yr fixed',
    milestone: 'Underwriting',
    milestoneIndex: 2,
    closingLabel: 'Closing Aug 12',
    processor: 'Alexis Rowe',
    realtor: 'Dana Whitfield · Compass',
    needsUpdate: true,
    loanDetails: [
      { label: 'Loan amount', value: '$429,000' },
      { label: 'Purchase price', value: '$465,000' },
      { label: 'Rate / points', value: '6.375% · 0.5 pts' },
      { label: 'Lock expires', value: 'Aug 19, 2026' },
      { label: 'LTV / DTI', value: '92% / 41%' },
      { label: 'Property', value: '1841 Grove St, Denver, CO' },
    ],
    processorNotes: [
      {
        author: 'Alexis Rowe · Processor',
        timestamp: 'Today, 8:42 AM',
        note: 'Appraisal received at value. Submitting to underwriting for final sign-off this morning.',
      },
      {
        author: 'Alexis Rowe · Processor',
        timestamp: 'Yesterday, 3:15 PM',
        note: 'Ordered updated VOE. No action needed from the loan officer.',
      },
    ],
    appraisal: [
      { label: 'Status', value: 'Received — at value' },
      { label: 'Appraised value', value: '$467,000' },
      { label: 'Vendor', value: 'Front Range Valuation' },
      { label: 'Received', value: 'Aug 10, 2026' },
    ],
    documents: [
      { name: 'Appraisal report.pdf', type: 'Appraisal', uploaded: 'Aug 10', status: 'Received' },
      { name: '2025 W-2.pdf', type: 'Income', uploaded: 'Aug 04', status: 'Accepted' },
      { name: 'Purchase contract.pdf', type: 'Contract', uploaded: 'Jul 29', status: 'Accepted' },
    ],
  },
  {
    id: 'LN-70092',
    borrower: 'Grace Lindqvist',
    amount: '$556,250',
    program: 'Jumbo 30-yr fixed',
    milestone: 'Clear to Close',
    milestoneIndex: 4,
    closingLabel: 'Closing Aug 05',
    processor: 'Devon Pratt',
    realtor: 'Sofia Delgado · Coldwell Banker',
    needsUpdate: true,
    loanDetails: [
      { label: 'Loan amount', value: '$556,250' },
      { label: 'Purchase price', value: '$695,000' },
      { label: 'Rate / points', value: '6.125% · 0 pts' },
      { label: 'Lock expires', value: 'Aug 08, 2026' },
      { label: 'LTV / DTI', value: '80% / 33%' },
      { label: 'Property', value: '77 Alpine Ct, Golden, CO' },
    ],
    processorNotes: [
      {
        author: 'Devon Pratt · Processor',
        timestamp: 'Today, 7:58 AM',
        note: 'Clear to close issued. Closing package sent to title. Borrower has not yet been notified.',
      },
    ],
    appraisal: [
      { label: 'Status', value: 'Complete' },
      { label: 'Appraised value', value: '$702,000' },
      { label: 'Vendor', value: 'Summit Appraisal Group' },
      { label: 'Received', value: 'Jul 24, 2026' },
    ],
    documents: [
      { name: 'Closing disclosure.pdf', type: 'Closing', uploaded: 'Aug 11', status: 'Sent' },
      { name: 'Homeowners policy.pdf', type: 'Insurance', uploaded: 'Aug 07', status: 'Accepted' },
    ],
  },
  {
    id: 'LN-70075',
    borrower: 'Trevor Nguyen',
    amount: '$588,000',
    program: 'Jumbo 7/6 ARM',
    milestone: 'Processing',
    milestoneIndex: 1,
    closingLabel: 'Closing Sep 02',
    processor: 'Alexis Rowe',
    realtor: 'Renee Ortiz · RE/MAX Alliance',
    needsUpdate: false,
    loanDetails: [
      { label: 'Loan amount', value: '$588,000' },
      { label: 'Purchase price', value: '$735,000' },
      { label: 'Rate / points', value: '5.875% · 0.25 pts' },
      { label: 'Lock expires', value: 'Sep 09, 2026' },
      { label: 'LTV / DTI', value: '80% / 36%' },
      { label: 'Property', value: '4120 Canyon Rim Dr, Golden, CO' },
    ],
    processorNotes: [
      {
        author: 'Alexis Rowe · Processor',
        timestamp: 'Yesterday, 11:20 AM',
        note: 'Initial disclosures signed. Appraisal ordered — expected Aug 18.',
      },
    ],
    appraisal: [
      { label: 'Status', value: 'Ordered' },
      { label: 'Appraised value', value: 'Pending' },
      { label: 'Vendor', value: 'Front Range Valuation' },
      { label: 'Expected', value: 'Aug 18, 2026' },
    ],
    documents: [
      { name: 'Initial disclosures.pdf', type: 'Disclosure', uploaded: 'Aug 10', status: 'Signed' },
      { name: 'Bank statements Q2.pdf', type: 'Assets', uploaded: 'Aug 09', status: 'In review' },
    ],
  },
  {
    id: 'LN-70041',
    borrower: 'Renata Villalobos',
    amount: '$429,900',
    program: 'Conventional 30-yr fixed',
    milestone: 'Conditions',
    milestoneIndex: 3,
    closingLabel: 'Closing Aug 22',
    processor: 'Devon Pratt',
    realtor: 'Dana Whitfield · Compass',
    needsUpdate: false,
    loanDetails: [
      { label: 'Loan amount', value: '$429,900' },
      { label: 'Purchase price', value: '$452,000' },
      { label: 'Rate / points', value: '6.25% · 0 pts' },
      { label: 'Lock expires', value: 'Aug 29, 2026' },
      { label: 'LTV / DTI', value: '95% / 35%' },
      { label: 'Property', value: '908 Sable Ave, Aurora, CO' },
    ],
    processorNotes: [
      {
        author: 'Devon Pratt · Processor',
        timestamp: 'Today, 9:05 AM',
        note: 'Two prior-to-doc conditions outstanding. Processing is collecting directly from the borrower.',
      },
    ],
    appraisal: [
      { label: 'Status', value: 'Received — at value' },
      { label: 'Appraised value', value: '$455,000' },
      { label: 'Vendor', value: 'Mile High Appraisal' },
      { label: 'Received', value: 'Aug 06, 2026' },
    ],
    documents: [
      { name: 'Gift letter.pdf', type: 'Assets', uploaded: 'Aug 08', status: 'In review' },
      { name: 'Appraisal report.pdf', type: 'Appraisal', uploaded: 'Aug 06', status: 'Accepted' },
    ],
  },
]
